<template>
  <section>
  
  <el-form :model="passwordForm" label-position="left" label-width="0px" class="demo-ruleForm login-container grijs">
    
		<h3 style='margin-bottom:60px;margin-top:10px'>
		  <span><img style='float:left;height:55px;xwidth:50px;margin-top:-5px' src='../../static/img/logo-261-213.jpg' /></span>
      <span style='float:right'>EnergyWatch</span><br/>
      <span style='float:right'>Change your Password</span>
		</h3>
    

    <div style='font-size:12px;margin:20px 0;font-family:Tahoma'> You have requested a password change, 
    so we send you this link. Please use the following field to enter a new value.
    Each Password should be minimal 8 characters.</div>
	 
    <el-form-item prop="password" style='margin-bottom:20px'>
      <el-input type="password" show-password v-model="passwordForm.password" auto-complete="off" placeholder="Your new password"></el-input>
    </el-form-item>    
    <el-form-item prop="retype" style='margin-bottom:20px'>
      <el-input type="password" show-password v-model="passwordForm.retype" auto-complete="off" placeholder="Retype password"></el-input>
    </el-form-item>    
    <el-form-item>
      <span v-if='passwordForm.password != passwordForm.retype' style='float:left;font-size:12px;color:red'>Passwords are not the same!</span>
      <el-button :disabled='isPasswordInValid()' type="primary" style="float:right" @click.native.prevent="changeSubmit">Change</el-button>
		</el-form-item>
  </el-form>
  </section>
</template>


<script>
  import api      from '../api/login';
	
  export default {
    data() {
      return {
        QID         : util.Initialize(this.$router,"*"),
        passwordForm: {
          id: "",
          password: "",
          retype: ""
        },
        rules: {
        },
        checked: true
      };
    },
    methods: {
      
     isPasswordInValid(password) {
        return (this.passwordForm.password.length < 8 || this.passwordForm.password != this.passwordForm.retype);
     },
     changeSubmit() {
        if (this.passwordForm.password != '')
			  {		
           let parg = this.stack;
           parg["password"] = this.passwordForm.password;

           api.savePassword(parg).then(response => {
             
             this.$message({
 			     	   title: "Your password has been changed",type: 'success',
               duration: 8000,
               dangerouslyUseHTMLString: true,
   			  	   message: "<div style='font-height:16px;line-height:30px;margin:10px'>Your password has been saved and you are redirected to login. Please use your new login credentials.</div>"
     		  	 });
             this.$router.push("login");

           });
        
           this.resetVisible = false;
         }

      }
    },
		mounted() {
			this.apiserver = window.apiserver;     
      //this.$refs.password.focus();
     
      if (this.$route.query) {
        this.stack = this.$route.query;
        this.passwordForm["id"] = this.stack.id;
      }
		},
  }

</script>

<style lang="scss" scoped>

	.login-container {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    margin: 180px auto;
    width: 350px;
    padding: 15px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
  }
  .grijs { background-color:#ebf4ff !important; }

</style>


// WEBPACK FOOTER //
// ChangePassword.vue?306ddca8